"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line import/no-extraneous-dependencies

function useOutsideAlerter(ref, action) {
  /**
   * Alert if clicked on outside of element
   */
  function handleClickOutside(event) {
    const getClass = document.getElementsByClassName('brixel-notification');
    const getClassMore = document.getElementsByClassName('block-click');
    if (getClass.length + getClassMore.length <= 1 && event.target && (0, _get.default)(ref, 'current', null) && (0, _isArray.default)((0, _get.default)(ref, 'current', null))) {
      setTimeout(() => {
        const curRef = action.id ? (0, _get.default)(ref, `current[${action.id}]`, null) : (0, _get.default)(ref, 'current[0]', null);
        if (curRef) {
          if (!curRef.contains(event.target)) {
            if (action.action === 'push') {
              action.history.push(action.loc);
            }
            if (action.action === 'function') {
              action.func();
            }
          }
        }
      }, 1);
    } else if (getClass.length + getClassMore.length === 0) {
      if ((0, _get.default)(ref, 'current', null) && !(0, _get.default)(ref, 'current', []).contains(event.target)) {
        if ((0, _get.default)(action, 'action', '') === 'push') {
          action.history.push(action.loc);
        }
        if ((0, _get.default)(action, 'action', '') === 'function') {
          action.func();
        }
      }
    }
  }
  (0, _react.useEffect)(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}
var _default = exports.default = useOutsideAlerter;